import Vue from 'vue'
import Vuetify, {
  VCol,
  VRow,
} from 'vuetify/lib'

import de from 'vuetify/es5/locale/de'
import fr from 'vuetify/es5/locale/fr'
import it from 'vuetify/es5/locale/it'

Vue.use(Vuetify, {
  components: {
    VCol,
    VRow,
  },
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { de, fr, it },
    current: 'de',
  },
  theme: {
    themes: {
      light: {
        primary: '#394b88',
        secondary: '#aea599',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
})
